import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "button"]

  toggle() {
    const expanded = this.buttonTarget.getAttribute("aria-expanded") !== "true"
    this.fullTarget.hidden = !expanded
    this.buttonTarget.setAttribute("aria-expanded", String(expanded))
    this.buttonTarget.textContent = expanded ? "Show less" : "Show more"
  }
}
